/**
 * Site identity and contact details.
 *
 * // TODO: nahradit reálnými údaji klienta (název firmy, e-mail, telefon, IČO, adresa).
 * Všechny hodnoty jsou záměrné placeholdery — nikde v projektu nevymýšlej obchodní data.
 */
export const site = {
  /** // TODO: reálný název firmy */
  name: "[Název firmy]",
  /** // TODO: reálná doména, používaná pro canonical/OG/sitemap */
  url: "https://www.vasefirma.cz",
  /** // TODO: reálný kontaktní e-mail */
  email: "info@vasefirma.cz",
  /** // TODO: reálný telefon */
  phone: "+420 000 000 000",
  /** // TODO: reálné IČO */
  companyId: "IČO 00000000",
  /** // TODO: reálné sídlo firmy */
  addressLine: "[Ulice 1, 000 00 Město]",
  /**
   * Nepovinný endpoint pro poptávky. Nastav přes NEXT_PUBLIC_LEAD_ENDPOINT.
   * Když není nastaven, formulář otevře mailto: fallback (nikdy falešný success).
   */
  leadEndpoint: process.env.NEXT_PUBLIC_LEAD_ENDPOINT ?? "",
  /** Jediné povolené video (viz BUILD CONTRACT). */
  youtubeId: "Haz6BOaCNz8",
  /** Kanonická adresa téhož videa — slouží jako cíl odkazu tlačítka přehrávače. */
  youtubeUrl: "https://www.youtube.com/watch?v=Haz6BOaCNz8",
} as const;

export type SiteConfig = typeof site;
